import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import { useLocation, useNavigate } from "react-router-dom";
import { AddButton } from "../../utils/commonComponent/Custom/Button";
import { submitSiteDelete } from "./../../utils/commonComponent/delete";
import { fetchQuery } from "./../../utils/commonComponent/fetched";
import ListSearchSection from "../../utils/commonComponent/Custom/ListSearchSection";
import ListView from "../../utils/commonComponent/Custom/listView";
import { DisciplineOptions } from "../disciplineMaster/disiplineConst";
import { getPermissions } from "../rbac/hasAccess";

const headers = ["id", "DisciplineName", "GroupName", "symbol"];

const fields = [
  { value: "disciplineId", label: "Discipline Name" },
  { value: "groupId", label: "Group Name" },
  { value: "symbol", label: "Symbol" },
];

const UnitMasterList = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const permissions = getPermissions(props.moduleId);
  const handleEdit = (row) => navigate(`/master/editUnit/${row.id}`);
  const handleDelete = (row) => submitSiteDelete("unit", row.id);

  const [unitList, setUnitList] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [searchBy, setSearchBy] = React.useState(sessionStorage.getItem("searchBy") || "symbol");
  const [searchKey, setSearchKey] = React.useState(sessionStorage.getItem("searchKey") || "");
  const [searched, setSearched] = React.useState(sessionStorage.getItem("searched") === "true" || false);
   // Pagination
  const [currentPage, setCurrentPage] = useState(() => Number(sessionStorage.getItem("ListPageCount") || 0));
  const [rowsPerPage, setRowsPerPage] = useState(() => Number(sessionStorage.getItem("ListRowsPerPage") || 30));

  const handlePaginationChange = (page, rows) => {
    setCurrentPage(page);
    setRowsPerPage(rows);
    // fetch new data from backend here
  };

  const getWhereClause = () => {
    const key = searchKey.trim().toLowerCase();
    let whereConditions = ["u.status = 1"];

    if (searchBy && key) {
      if (searchBy === "groupId") {
        whereConditions.push(`LOWER(g.groupName) LIKE '%${key}%'`);
      } else if (searchBy === "symbol") {
        whereConditions.push(`LOWER(u.symbol) LIKE '%${key}%'`);
      } else if (searchBy === "disciplineId") {
        const matches = DisciplineOptions.filter((opt) =>
          opt.label.toLowerCase().includes(key)
        ).map((opt) => opt.id);

        if (matches.length) {
          whereConditions.push(`u.disciplineId IN (${matches.join(",")})`);
        }
      }
    }

    return whereConditions.length
      ? `WHERE ${whereConditions.join(" AND ")}`
      : "";
  };

  const getDataQuery = () => {
    const whereClause = getWhereClause();

    let paginationSettings = "";
    if (rowsPerPage !== -1) {
      paginationSettings = `LIMIT ${rowsPerPage} OFFSET ${rowsPerPage * Number(currentPage)
        }`;
    }

    return `SELECT u.id, u.disciplineId, u.groupId, u.symbol, g.groupName AS GroupName FROM unit u LEFT JOIN discipline g ON u.groupId = g.id ${whereClause} ORDER BY u.id DESC ${paginationSettings};`;
  };

  const getCountQuery = () => {
    const whereClause = getWhereClause();

    return `SELECT COUNT(DISTINCT u.id) AS totalRows FROM unit u LEFT JOIN discipline g ON u.groupId = g.id ${whereClause};`;
  };

  const fetchData = async () => {
    try {
      const [unitData, countResult] = await Promise.all([
        fetchQuery(getDataQuery()),
        fetchQuery(getCountQuery()),
      ]);

      const formattedData = unitData.map((item) => ({
        ...item,
        DisciplineName:
          DisciplineOptions.find((key) => key.id == item.disciplineId)?.label ||
          "",
      }));

      setUnitList(formattedData);
      setTotalRows(countResult?.[0]?.totalRows || 0); // 👈 pagination state
    } catch (error) {
      console.error("Error fetching unit data:", error);
    }
  };

  const handleSearch = () => {
    if (!searchBy || !searchKey.trim()) {
      alert("Please select a search field and enter a search value.");
      return;
    }
    fetchData();
    setSearched(true);
    // Save search state to sessionStorage
    sessionStorage.setItem("searchBy", searchBy);
    sessionStorage.setItem("searchKey", searchKey);
    sessionStorage.setItem("searched", "true");
    sessionStorage.setItem("currentPath", location.pathname);
    sessionStorage.setItem("ListPageCount", 0);
    setCurrentPage(0);
  };

  const clearSearch = () => {
    setSearched(false);
    setSearchBy("symbol");
    setSearchKey("");
     // Clear all employee list session storage
    sessionStorage.removeItem("ListPageCount");
    sessionStorage.removeItem("ListRowsPerPage");
    sessionStorage.removeItem("searchBy");
    sessionStorage.removeItem("searchKey");
    sessionStorage.removeItem("searched");
    setCurrentPage(0);
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, rowsPerPage]);

  useEffect(() => {
    if (searched == false) {
      fetchData();
    }
  }, [searched]);

  return (
    <>
      {(permissions.create || permissions.allAccess) && (
        <AddButton
          id="btn-add-outline"
          to="/master/editUnit/0"
          label="Add Unit"
          icon={<AddIcon fontSize="small" />}
        />
      )}
      <ListSearchSection
        title="Search Unit"
        fields={fields}
        onSearch={handleSearch}
        searchKey={searchKey}
        setSearchKey={setSearchKey}
        searchBy={searchBy}
        setSearchBy={setSearchBy}
        clearSearch={clearSearch}
        searched={searched}
        setSearched={setSearched}
      />

      <ListView
        headers={headers}
        data={unitList}
        actions={{
          edit: handleEdit,
          delete: handleDelete,
        }}
        showCheckbox={true}
        deleteTableName={"unit"}
        moduleId={props.moduleId}
        currentPage={currentPage}
        rowsPerPage={rowsPerPage}
        totalRows={totalRows}
        onPaginationChange={handlePaginationChange}
      />
    </>
  );
};

export default UnitMasterList;
